import React, { lazy, Suspense, useLayoutEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./UI/Header/Header";
import Footer from "./UI/Footer/Footer";
import Home from "./Component/Home/Home";

// Lazy-load inner routes to keep the main bundle extremely small while ensuring instant home paint
const ClinicInstruction = lazy(() => import("./Component/ClinicInstruction/ClinicInstruction"));
const DoctorProfile = lazy(() => import("./Component/DoctorProfile/DoctorProfile"));
const SearchPage = lazy(() => import("./Component/SearchPage/SearchPage"));
const ThankYou = lazy(() => import("./Component/ThankYou/ThankYou"));
const ClinicList = lazy(() => import("./Component/ClinicList/ClinicList"));
const Doctor = lazy(() => import("./Component/Doctor/Doctor"));
const NotFound = lazy(() => import("./Component/NotFound/NotFound"));

// Sleek, zero-CLS fallback loader
const PageLoader = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="w-9 h-9 border-3 border-primary/20 border-t-primary rounded-full animate-spin"></div>
  </div>
);

// Scroll to top on route change
const Wrapper = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return children;
};

function App() {
  return (
    <Router basename="/app">
      <Wrapper>
        <Header />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* Standard Root Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/clinic/:slug" element={<ClinicInstruction />} />
            <Route path="/doctor/:slug" element={<DoctorProfile />} />
            <Route path="/thankyou" element={<ThankYou />} />
            <Route path="/clinic" element={<ClinicList />} />
            <Route path="/clinic/province/:provinceSlug" element={<ClinicList />} />
            <Route path="/clinic/province/district/:districtSlug" element={<ClinicList />} />
            <Route path="/clinic/province/district/secretariat/:secretariatSlug" element={<ClinicList />} />
            <Route path="/clinic/province/:provinceSlug/district/:districtSlug" element={<ClinicList />} />
            <Route path="/clinic/province/:provinceSlug/district/:districtSlug/secretariat/:secretariatSlug" element={<ClinicList />} />
            <Route path="/doctor" element={<Doctor />} />

            {/* /app Prefixed Routes for backwards compatibility */}
            <Route path="/app" element={<Home />} />
            <Route path="/app/" element={<Home />} />
            <Route path="/app/search" element={<SearchPage />} />
            <Route path="/app/clinic/:slug" element={<ClinicInstruction />} />
            <Route path="/app/doctor/:slug" element={<DoctorProfile />} />
            <Route path="/app/thankyou" element={<ThankYou />} />
            <Route path="/app/clinic" element={<ClinicList />} />
            <Route path="/app/clinic/province/:provinceSlug" element={<ClinicList />} />
            <Route path="/app/clinic/province/district/:districtSlug" element={<ClinicList />} />
            <Route path="/app/clinic/province/district/secretariat/:secretariatSlug" element={<ClinicList />} />
            <Route path="/app/clinic/province/:provinceSlug/district/:districtSlug" element={<ClinicList />} />
            <Route path="/app/clinic/province/:provinceSlug/district/:districtSlug/secretariat/:secretariatSlug" element={<ClinicList />} />
            <Route path="/app/doctor" element={<Doctor />} />

            {/* Catch-all */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Footer />
      </Wrapper>
    </Router>
  );
}

export default App;
